import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.903 8c.06.629.097 1.292.097 2a1 1 0 0 1-2 0c0-.713-.039-1.378-.105-2H8.092c-.139 1.33-.14 2.67-.004 4H10a1 1 0 0 1 0 2H8.416c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002a1.008 1.008 0 0 1 1.07.925 1 1 0 0 1-.924 1.07C10.979 20.004 10 20 10 20 4.486 20 0 15.514 0 10 0 4.485 4.486 0 10 0s10 4.485 10 10c0 .379-.036.749-.079 1.116a1.001 1.001 0 0 1-1.987-.233c.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2h-3.834zM9.988 2.036c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zM2.263 12h3.819a21.604 21.604 0 0 1-.095-1.996c0-.67.033-1.338.096-2.004h-3.82A7.946 7.946 0 0 0 2 10a7.96 7.96 0 0 0 .263 2zm.819 2a8.031 8.031 0 0 0 4.437 3.601A16.293 16.293 0 0 1 6.371 14H3.082zm3.291-8a16.235 16.235 0 0 1 1.15-3.603A8.03 8.03 0 0 0 3.082 6h3.291zm7.239 0h3.305a8.029 8.029 0 0 0-4.465-3.612A16.128 16.128 0 0 1 13.612 6z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.223 18.945l-2.55-5.61a.5.5 0 0 1 .662-.662l5.61 2.55a.5.5 0 0 1 .017.903l-1.742.87a.5.5 0 0 0-.223.224l-.871 1.742a.5.5 0 0 1-.903-.017z"
});

var SvgDomainsMajor = function SvgDomainsMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgDomainsMajor as S };
